import React, { SVGProps } from "react";
import { ReactComponent as LogoSVG } from "./logo.svg";

const Logo: React.FC<SVGProps<SVGElement>> = (props) => <LogoSVG {...props} />;

export default Logo;
